import React, { createContext, useState, type ReactNode } from "react";

import MultipleLocModal from "../components/MultipleLocModal";
import { type DocumentLocOption } from "../types";

export type MultipleLocReturn = {
  openModal: (
    locs: DocumentLocOption[],
    onConfirm: (selectedLocs: string[]) => void,
  ) => void;
};

const MultipleLocContext = createContext<MultipleLocReturn | undefined>(
  undefined,
);

export { MultipleLocContext };

type MultipleLocProviderProps = {
  children: ReactNode;
};

export const MultipleLocProvider = ({
  children,
}: MultipleLocProviderProps): React.JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const [locs, setLocs] = useState<DocumentLocOption[]>([]);
  const [onConfirmCallback, setOnConfirmCallback] = useState<
    ((selectedLocs: string[]) => void) | null
  >(null);

  const openModal = (
    locs: DocumentLocOption[],
    onConfirm: (selectedLocs: string[]) => void,
  ): void => {
    setLocs(locs);
    setOnConfirmCallback(() => onConfirm);
    setIsOpen(true);
  };

  const handleClose = (): void => {
    setIsOpen(false);
    setLocs([]);
    setOnConfirmCallback(null);
  };

  const handleConfirm = (selectedLocs: string[]): void => {
    onConfirmCallback?.(selectedLocs);
    handleClose();
  };

  return (
    <MultipleLocContext.Provider value={{ openModal }}>
      {children}
      <MultipleLocModal
        isOpen={isOpen}
        locs={locs}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </MultipleLocContext.Provider>
  );
};
